export const actionTypes = {
    UPDATE_PROMOTION_FILTERS: 'UPDATE_PROMOTION_FILTERS',
    UPDATE_PROMO_STATUS_FILTER: 'UPDATE_PROMO_STATUS_FILTER',
    CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
    UPDATE_NOTIFICATION_FILTERS: 'UPDATE_NOTIFICATION_FILTERS',
    CLEAR_ALL_NOTIFICATION_FILTERS: 'CLEAR_ALL_NOTIFICATION_FILTERS',
}

export const updateNotificationFilters = payload => ({
    type: actionTypes.UPDATE_NOTIFICATION_FILTERS,
    payload,
})

export const clearAllNotificationFilters = () => ({
    type: actionTypes.CLEAR_ALL_NOTIFICATION_FILTERS,
})
